// src/Dashboard/pages/user/Absences/components/AbsenceSkeleton.jsx

import React from "react";

export default function AbsenceSkeleton() {
  return (
    <div className="space-y-4">
      <div className="h-24 animate-pulse rounded-[24px] bg-slate-200 dark:bg-slate-800" />
      <div className="h-28 animate-pulse rounded-[24px] bg-slate-200 dark:bg-slate-800" />
      <div className="h-80 animate-pulse rounded-[24px] bg-slate-200 dark:bg-slate-800" />
    </div>
  );
}